import api from './api';
import type {
  EmpresaIntegracaoContract,
  UpdateEmpresaIntegracaoPayloadContract,
  UpdateEmpresaRedirecionamentoPayloadContract,
  CreateClientApiCredentialPayloadContract,
  CreateClientApiCredentialResponseContract,
  RevokeClientApiCredentialResponseContract,
} from '@sstexames/shared-types';

export const integracoesService = {
  async getIntegracao(): Promise<EmpresaIntegracaoContract> {
    const response = await api.get<EmpresaIntegracaoContract>('/integracoes');
    return response.data;
  },

  async updateIps(
    payload: UpdateEmpresaIntegracaoPayloadContract,
  ): Promise<{ id: number; nome: string; api_allowed_ips?: string | null }> {
    const response = await api.patch<{
      id: number;
      nome: string;
      api_allowed_ips?: string | null;
    }>('/integracoes/ips', payload);
    return response.data;
  },

  async updateRedirecionamento(
    payload: UpdateEmpresaRedirecionamentoPayloadContract,
  ): Promise<{
    id: number;
    nome: string;
    email_redirecionamento?: string | null;
    whatsapp_redirecionamento?: string | null;
  }> {
    const response = await api.patch<{
      id: number;
      nome: string;
      email_redirecionamento?: string | null;
      whatsapp_redirecionamento?: string | null;
    }>('/integracoes/redirecionamento', payload);
    return response.data;
  },

  async createCredencial(
    payload: CreateClientApiCredentialPayloadContract,
  ): Promise<CreateClientApiCredentialResponseContract> {
    const response = await api.post<CreateClientApiCredentialResponseContract>(
      '/integracoes/credenciais',
      payload,
    );
    return response.data;
  },

  async revokeCredencial(
    id: number,
  ): Promise<RevokeClientApiCredentialResponseContract> {
    const response = await api.delete<RevokeClientApiCredentialResponseContract>(
      `/integracoes/credenciais/${id}`,
    );
    return response.data;
  },
};

export type {
  EmpresaIntegracaoContract,
  UpdateEmpresaIntegracaoPayloadContract,
  CreateClientApiCredentialPayloadContract,
  CreateClientApiCredentialResponseContract,
  RevokeClientApiCredentialResponseContract,
};
